import "../Foot.css";

function Foot() {
  return (
    <div class="flex justify-center w-full border-t px-2">
      <div class="w-full pb-10 pt-8 md:max-w-screen-md lg:max-w-screen-lg">
        <div class="absolute md:right-44 right-8 -mt-14"></div>
        <div class="flex items-center flex-col border-b border-black-300 pb-10">
          <div class="w-full">
            <img
              alt="logo pijarmahir"
              class="cursor-pointer"
              height="77"
              src="https://camp.pijarmahir.id/static/logo/PIJAR_CAMP.svg"
              width="128"
              href="/"
            />
            <div class="flex items-center">
              <p class="text-xs font-medium text-black-500 mr-2">Powered By</p>
              <span
                style={{
                  boxsizing: "border-box",
                  display: "inline-block",
                  overflow: "hidden",
                  width: "initial",
                  height: "initial",
                  background: "none",
                  opacity: "1",
                  border: "0",
                  margin: "0",
                  padding: "0",
                  position: "relative",
                  maxwidth: "100%",
                }}
              >
                <span
                  style={{
                    boxsizing: "border-box",
                    display: "block",
                    width: "initial",
                    height: "initial",
                    background: "none",
                    opacity: "1",
                    border: "0",
                    margin: "0",
                    padding: "0",
                    maxwidth: "100%",
                  }}
                >
                  <img
                    style={{
                      display: "block",
                      maxwidth: "100%",
                      width: "initial",
                      height: "initial",
                      background: "none",
                      opacity: "1",
                      border: "0",
                      margin: "0",
                      padding: "0",
                    }}
                    alt=""
                    aria-hidden="true"
                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2780%27%20height=%2754%27/%3e"
                  />
                </span>
                <img
                  alt="logo pijarmahir"
                  src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                  decoding="async"
                  data-nimg="intrinsic"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    bottom: "0",
                    right: "0",
                    boxsizing: "border-box",
                    padding: "0",
                    border: "none",
                    margin: "auto",
                    display: "block",
                    width: "0",
                    height: "0",
                    minwidth: "100%",
                    maxwidth: "100%",
                    minheight: "100%",
                    maxheight: "100%",
                  }}
                />
                <noscript>
                  <img
                    alt="logo pijarmahir"
                    src="https://camp.pijarmahir.id/static/logo/TELKOM_INDONESIA.png"
                    decoding="async"
                    data-nimg="intrinsic"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      bottom: "0",
                      right: "0",
                      boxsizing: "border-box",
                      padding: "0",
                      border: "none",
                      margin: "auto",
                      display: "block",
                      width: "0",
                      height: "0",
                      minwidth: "100%",
                      maxwidth: "100%",
                      minheight: "100%",
                      maxheight: "100%",
                    }}
                    loading="lazy"
                  />
                </noscript>
              </span>
            </div>
          </div>
          <div class="w-full flex flex-wrap flex-col md:flex-row mt-8">
            <div class="flex justify-start flex-col w-full md:w-1/4 mb-4 pb-4 pr-2 border-b border-black-300 md:border-none">
              <h3 class="font-semibold font-heading text-black-800 mb-4">
                Produk
              </h3>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="/class"
                >
                  Bootcamp Full Time
                </a>
              </div>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="https://pijarmahir.id"
                >
                  Pijar Mahir
                </a>
              </div>
            </div>
            <div class="flex justify-start flex-col w-full md:w-1/4 mb-4 pb-4 pr-2 border-b border-black-300 md:border-none">
              <h3 class="font-semibold font-heading text-black-800 mb-4">
                Support
              </h3>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="/help/about-us"
                >
                  Tentang Pijar Camp
                </a>
              </div>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="/help/faq"
                >
                  FAQ
                </a>
              </div>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="/help/contact-us"
                >
                  Hubungi Kami
                </a>
              </div>
            </div>
            <div class="flex justify-start flex-col w-full md:w-1/4 mb-4 pb-4 pr-2 border-b border-black-300 md:border-none">
              <h3 class="font-semibold font-heading text-black-800 mb-4">
                Info Lainnya
              </h3>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="/info-admission"
                >
                  Info Penerimaan
                </a>
              </div>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="/job-connect"
                >
                  Job Connect
                </a>
              </div>
              <div class="w-full mb-2">
                <a
                  class="hover:underline font-heading text-center md:text-left w-full md:w-1/3 text-black-800 py-2"
                  href="/isa-payment"
                >
                  Income Share Agreement
                </a>
              </div>
            </div>
            <div class="flex justify-center md:justify-start flex-col flex-wrap mb-2 md:mb-0 md:w-1/4 pr-2">
              <h3 class="w-full font-semibold font-heading text-black-800 mb-4">
                Ikuti Kami di
              </h3>
              <div class="flex flex-wrap">
                <a
                  class="w-auto mb-4 mr-4"
                  href="https://www.instagram.com/pijarmahir.id/"
                  rel="nopoper noopener noreferrer"
                  target="_blank"
                >
                  <img
                    alt="instagram"
                    src="https://camp.pijarmahir.id/static/icons/instagram_clean.svg"
                  />
                </a>
                <a
                  class="w-auto mb-4 mr-4"
                  href="https://www.linkedin.com/company/pijar-mahir"
                  rel="nopoper noopener noreferrer"
                  target="_blank"
                >
                  <img
                    alt="linkedin"
                    src="https://camp.pijarmahir.id/static/icons/linkedin_clean.svg"
                  />
                </a>
                <a
                  class="w-auto mb-4 mr-4"
                  href="https://www.facebook.com/pijarmahir.id/"
                  rel="nopoper noopener noreferrer"
                  target="_blank"
                >
                  <img
                    alt="facebook"
                    src="https://camp.pijarmahir.id/static/icons/facebook_clean.svg"
                  />
                </a>
                <a
                  class="w-auto mb-4 mr-4"
                  href="https://twitter.com/pijarmahir"
                  rel="nopoper noopener noreferrer"
                  target="_blank"
                >
                  <img
                    alt="twitter"
                    src="https://camp.pijarmahir.id/static/icons/twitter_clean.svg"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col md:flex-row pt-6">
          <div class="flex items-center">
            <a
              class="hover:underline text-sm text-center md:text-left text-black-800 py-2"
              href="/help/privacy-policy"
            >
              Kebijakan Privasi
            </a>
            <p class="mx-2">•</p>
            <a
              class="hover:underline text-sm text-left text-black-800 py-2"
              href="/help/term-condition"
            >
              Syarat dan Ketentuan
            </a>
          </div>
          <p class="text-sm flex-1 text-left md:text-right text-gray-700 py-2">
            ©2020-2022 Pijar Mahir. All Right Reserved
          </p>
        </div>
      </div>
    </div>
  );
}

export default Foot;
